<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label" translate>{{ getTitle() }}</h3>
    </div>
  </div>
  <form class="form form-group-seperator-dashed" [formGroup]="uploadDocsForm">
    <div class="navi-hover scroll card-body" [perfectScrollbar]="{ wheelPropagation: false }">
      <div class="card-body-progress">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>
      <kt-alert *ngIf="hasFormErrors" [showCloseButton]="false" type="warn" [duration]="10000">
        {{ 'AUTH.VALIDATION.INVALID_OR_REQUIRED' | translate }}
      </kt-alert>
      <div class="form-group pt-0">
        <div class="row mb-1">
          <div class="col kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'UPLOAD_MARKETING_DOCS.TOPIC' | translate }}</mat-label>
              <input matInput formControlName="topic" required />
              <mat-error *ngIf="isControlHasError('topic', 'required')">
                Topic field is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'UPLOAD_MARKETING_DOCS.DESCRIPTION' | translate }}</mat-label>
              <textarea
                matInput
                formControlName="description"
                maxlength="1000"
                rows="7"
                required
              ></textarea>
              <mat-error *ngIf="isControlHasError('description', 'required')">
                Description field is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col col-sm-12">
            <kt-tags [controlObject]="tags" [appearance]="'fill'"></kt-tags>
          </div>
        </div>
        <div class="mat-form-field mat-form-field-appearance-fill mb-1">
          <div class="mat-form-field-wrapper">
            <button class="btn btn-secondary" (click)="fileInput.click()">
              Choose File<span
                [class.text-danger]="isControlHasError('file', 'required')"
                class="ml-1"
                >*</span
              >
            </button>
            <input
              hidden
              formControlName="file"
              #fileInput
              type="file"
              name="attachments"
              (change)="onFileChange($event)"
            />
            <div class="mat-form-field-subscript-wrapper">
              <mat-error style="font-size: 10px" *ngIf="isControlHasError('file', 'required')">
                Attachments field is required
              </mat-error>
            </div>
          </div>
        </div>
        <kt-general-autocomplete
          #docCategoryAutocomplete
          [label]="'UPLOAD_MARKETING_DOCS.CATEGORY' | translate"
          [dataPath]="'data'"
          [loadItemsFunction]="getDocCategoryAutocomplete"
          [optionFormatter]="formatDocCategoryOption"
          [valueFormatter]="formatDocCategoryOption"
          [control]="uploadDocsForm.get('docCategory')"
          [change]="onDocCategoryChange.bind(this)"
          [required]="true"
          [readOnly]="false"
        ></kt-general-autocomplete>
        <kt-custom-progress-bar
          *ngIf="showFileLoader | async"
          [requests]="uploadRequests"
          [totalFileSize]="totalFileSize"
          (callback)="callbackOnFileLoad()"
        ></kt-custom-progress-bar>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            (click)="close()"
            type="button"
            mat-raised-button
            cdkFocusInitial
            matTooltip="Cancel"
          >
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            type="button"
            mat-raised-button
            color="primary"
            [disabled]="clicked"
            (click)="submit()"
            matTooltip="Save"
          >
            <span translate="GLOBAL.SAVE">Save</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
